import React from 'react';
import { ShieldAlert } from 'lucide-react';

/**
 * SafetyNotice — persistent legal/safety banner shown on every v2
 * Plan and Perform screen.  Never hide this without a code change.
 */
export default function SafetyNotice({ dense = false }) {
  return (
    <aside
      className={`jbv2-safety ${dense ? 'jbv2-safety--dense' : ''}`}
      role="note"
      aria-label="Safety notice"
      data-testid="jbv2-safety-notice"
    >
      <ShieldAlert size={16} strokeWidth={2.2} aria-hidden="true" />
      <span>
        <strong>AskStewie supports job planning and Human Performance.</strong>{' '}
        It does not replace approved procedures, switching orders, clearances, safety rules,
        training, or qualified judgment.
      </span>
    </aside>
  );
}
